import { Input } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext, FieldValues, FieldPath } from "react-hook-form"
import type { InputFieldProps } from "./InputField.types"

const { TextArea } = Input

/**
 * InputField component that integrates React Hook Form with Ant Design Input
 * Uses react-hook-form-antd's FormItem for seamless integration
 */
export function InputField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder,
  disabled,
  size,
  variant,
  prefix,
  suffix,
  allowClear,
  maxLength,
  showCount,
  type = "text",
  autoComplete,
  multiline = false,
  rows = 4,
  autoSize,
}: InputFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
    >
      {multiline ? (
        <TextArea
          placeholder={placeholder}
          disabled={disabled}
          allowClear={allowClear}
          maxLength={maxLength}
          showCount={showCount}
          rows={rows}
          autoSize={autoSize}
          autoComplete={autoComplete}
        />
      ) : (
        <Input
          placeholder={placeholder}
          disabled={disabled}
          size={size}
          variant={variant}
          prefix={prefix}
          suffix={suffix}
          allowClear={allowClear}
          maxLength={maxLength}
          showCount={showCount}
          type={type}
          autoComplete={autoComplete}
        />
      )}
    </FormItem>
  )
}
